import React from "react";

const AboutUs = () => {
  return (
    <div className="bg-white text-gray-800">
      {/* Hero Section */}
      <section className="text-center px-6 py-16 bg-[#f7f7f7]">
        <h2 className="text-5xl font-bold text-[#b7b7a1]">About Us</h2>
        <p className="text-lg text-gray-600 mt-4 max-w-3xl mx-auto">
          Your Trusted Partner for 26 years in Land & Building Documentation,
          Registrations, Legal Services, Property Consultant with Clarity,
          Compliance, and Confidence
        </p>
      </section>

      {/* Company Overview */}
      <section className="px-8 py-12 max-w-5xl mx-auto">
        <h3 className="text-3xl font-semibold mb-6 text-[#333]">
          CHARETHRI BUSINESS SOLUTIONS LLP
        </h3>
        <p className="text-gray-700 mb-4 leading-relaxed">
          <strong>Established:</strong> 1997
        </p>
        <p className="text-gray-700 leading-relaxed text-justify mb-4">
          The Proprietor Company named <strong>“Siddharth Associates”</strong>{" "}
          was founded by <strong>Srenivasa M</strong> and was established in
          1997. It was a Prime Property Consultants, a leading firm specialising
          in property consultancy and related documentation services.
          Mr.&nbsp;Srenivasa M was trained and groomed by his uncle. He had 19
          years (till 2016) of rich experience in Property Documentation and
          real estate consulting. We have built a reputation for delivering
          exceptional services that cater to the diverse needs of our clients.
        </p>
        <p className="text-gray-700 leading-relaxed text-justify mb-4">
          Thereafter, the founder became an Advocate; in the meantime, he
          trained a professional team that included his uncle and blood brother,
          and they took the business further and completed massive projects on a
          turnkey basis. After rescission, the company was in a lame and
          business-slow phase and completed very few small projects: his son,{" "}
          <strong>Mr. Chaithania Srinivas</strong>, and his wife,{" "}
          <strong>Mrs. Usha Srinivas</strong> took over the company and
          registered a partnership company after Corona, named{" "}
          <strong>“Sugata Associates”</strong>; they retained his uncle’s
          professional team. The company concentrated on liaising with work and
          documentation for all real estate needs.
        </p>
        <p className="text-gray-700 leading-relaxed text-justify mb-4">
          The company had an office in BDA Complex, Koramangala 4th Block,
          Bangalore-560034, and in the year 2024, the same company upgraded from
          a partnership firm to a Limited Liability Partnership company. It had
          a new name registered as{" "}
          <strong>“CHARETHRI BUSINESS SOLUTIONS LLP”</strong> with a unique
          business idea <em>“ONE STOP FOR LAND & BUILDING DOCUMENTATION
          SERVICES”</em>—his son, <strong>Mr. Chaithania Srinivas</strong>, his
          brother, <strong>Mr. Umashanker M</strong> and his wife,{" "}
          <strong>Mrs. Usha Srinivas</strong> has a branch office at the K R
          Puram Sub-registrar Office Building, Bangalore. Now, the company
          operates from Koramangala and K R Puram with a professional team
          within geographical limits around Bangalore and the nearby districts
          of Karnataka.
        </p>
      </section>

      {/* Services */}
      <section className="bg-[#f9f9f9] px-8 py-12">
        <div className="max-w-5xl mx-auto">
          <h3 className="text-3xl font-semibold mb-4 text-[#333]">
            Our Services
          </h3>
          <p className="text-gray-700 leading-relaxed text-justify mb-4">
            Our Services Include Title Deed Verification, Encumbrance Checks,
            Sale Agreement Draft and review, No-Objection Certificate (NOC)
            Assistance, Succession and mutation Deeds, and Comprehensive
            Portfolio Management. Make informed decisions with data-driven
            insights and expert market analysis. We help you identify
            opportunities and maximise the value of your investments.
          </p>
          <p className="text-gray-700 leading-relaxed text-justify mb-4">
            Our deep expertise in Documentation-Land & Building, Registrations,
            Legal Services, and Property Consultant law ensures your interests
            are protected at every stage. We offer proactive legal solutions to
            ensure full compliance and mitigate risk.
          </p>
          <p className="text-gray-700 leading-relaxed text-justify mb-4">
            At CHARETHRI BUSINESS SOLUTIONS, we understand that
            Documentation-Land & Building, Registrations, Legal Services,
            Property Consultant is more than just transactions and
            properties—it's about futures, legacies, and dreams. Navigating the
            complex landscape of Documentation-Land & Building, Registrations,
            Legal Services, Property Consultant, and market dynamics can be
            daunting. That's where we step in.
          </p>
          <p className="text-gray-700 leading-relaxed text-justify">
            We are a specialised firm offering an integrated suite of services
            designed to safeguard your Documentation-Land & Building,
            Registrations, Legal Services, Property Consultant investments. From
            meticulous document verification to strategic property consultancy
            and robust legal support, we are your single point of contact for a
            seamless, secure, and prosperous Documentation-Land & Building,
            Registrations, Legal Services, Property Consultant journey.
          </p>
        </div>
      </section>

      {/* Mission */}
      <section className="px-8 py-12">
        <div className="max-w-5xl mx-auto">
          <h3 className="text-3xl font-semibold mb-4 text-[#333]">
            Our Mission
          </h3>
          <p className="text-gray-700 leading-relaxed text-justify">
            Our mission is to eliminate the inherent risks and complexities in
            Documentation-Land & Building, Registrations, Legal Services,
            Property Consultant, providing our clients with unparalleled
            expertise and peace of mind.
          </p>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="bg-[#f9f9f9] px-8 py-12">
        <div className="max-w-5xl mx-auto">
          <h3 className="text-3xl font-semibold mb-4 text-[#333]">
            Why Choose CHARETHRI BUSINESS SOLUTIONS
          </h3>
          <ul className="list-disc pl-6 space-y-3 text-gray-700 leading-relaxed">
            <li>
              <strong>Integrated Expertise:</strong> Our unique synergy of legal
              acumen, documentation proficiency, and market knowledge provides a
              360-degree solution you won't find elsewhere.
            </li>
            <li>
              <strong>Uncompromising Due Diligence:</strong> We leave no stone
              unturned. Our rigorous verification processes are designed to
              identify potential red flags before they become problems.
            </li>
            <li>
              <strong>Client-Centric Philosophy:</strong> We believe in building
              long-term relationships, not just closing deals. Your goals are
              our priorities, and your confidence is our measure of success.
            </li>
            <li>
              <strong>Transparency & Integrity:</strong> We operate honestly,
              providing clear advice, transparent pricing, and straightforward
              communication. You will always know exactly where you stand.
            </li>
            <li>
              <strong>Expert Team:</strong> Our team comprises seasoned property
              consultants, legal experts, and documentation specialists with a
              proven track record in the industry.
            </li>
          </ul>
        </div>
      </section>

      {/* Vision */}
      <section className="px-8 py-12">
        <div className="max-w-5xl mx-auto">
          <h3 className="text-3xl font-semibold mb-4 text-[#333]">
            Our Vision
          </h3>
          <p className="text-gray-700 leading-relaxed text-justify">
            To be the most trusted and authoritative name in
            Documentation-Land & Building, Registrations, Legal Services,
            Property Consultant advisory, setting the benchmark for excellence,
            ethics, and client satisfaction.
          </p>
        </div>
      </section>

      {/* Connect With Us */}
      <section className="bg-[#f9f9f9] px-8 py-12">
        <div className="max-w-5xl mx-auto text-center">
          <h3 className="text-3xl font-semibold mb-4 text-[#333]">
            Connect With Us
          </h3>
          <p className="text-gray-700 leading-relaxed">
            Let us help you confidently navigate your next property decision.
            Whether you are a first-time homebuyer, a seasoned investor, or a
            business looking to expand your portfolio, CHARETHRI BUSINESS
            SOLUTIONS guides you every step.
          </p>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="px-8 py-6 text-sm text-gray-500 max-w-5xl mx-auto">
        Disclaimer: This profile is informational and does not constitute legal
        advice. Please consult with our experts for guidance on your specific
        situation.
      </section>
    </div>
  );
};

export default AboutUs;
